import { api, ApiError } from './api';
import { useDiagramViewStore } from '../store/useDiagramViewStore';

/** Saves are chained per diagram so an older autosave can never overwrite a newer one on the server. */
const queues = new Map<string, Promise<unknown>>();

export function pushDiagram(id: string, name: string, data: unknown): void {
  const previous = queues.get(id) ?? Promise.resolve();
  const next = previous
    .catch(() => undefined)
    .then(() => api.put(`/api/diagrams/${id}`, { name, data }))
    .catch((err: unknown) => {
      const message = err instanceof ApiError && err.status === 403 ? 'You only have view access to this diagram — changes were not saved' : 'Could not save your changes to the server';
      useDiagramViewStore.getState().showToast(message);
    });
  queues.set(id, next);
}
